export const NAME_MAP = {
  "Class of 1978 Life Sciences Center": "Life Sciences Ctr",
  "Baker, Berry, Carson Library - Complex": "Baker Library",
  "Rockefeller Ctr for the Social Sciences": "Rockefeller Ctr",
  "Engineer and Comp Science Ctr": "ENGS & CS Ctr",
  "Burke Chemistry Laboratory": "Burke Lab",
  "Class of 1953 Commons": "1953 Commons",
};
